<div class="p-3">

  <h3 class="fs-24 hex-65-grey fw-700">Assignment Details</h3>
  <!-- <div class="pb-2 text-end">
  <button class="btn btn-primary" (click)="location.back()">Go Back</button>
</div> -->
<div class="row mb-3">
  <div class="col-md-9 col-12">
    <div class="card card-default">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <div class="assignment d-flex">
            <span class="badge bg-primary" style="font-size:large">{{is_lead ? 'Lead ID' : 'Ticket ID'}} :
            {{is_lead ? (assignment && assignment.lead_id ? assignment.lead_id : requestId) : (assignment && assignment.req_id ? assignment.req_id : "")}} </span>

            @if (document_required_btn == 1) {
              <div class="indicator blink_missing bg-warning mx-2"
                style="align-items: center; border-radius: 4px;" [tooltip]="tooltipDocs" placement="right">
                <p class="px-2 py-2 fs-14 text-white fw-700" style="margin-bottom: 0;">
                  Document Required
                </p>
              </div>
            }

            <ng-template #tooltipDocs>
              <div class="docs-toltip text-start">
                @for (doc of authDocs; track doc; let i = $index; let last = $last) {
                  {{ i + 1 }}. {{ doc.doc_name }}@if (!last) {
                  <span><br></span>
                }
              }
            </div>
          </ng-template>
        </div>

        @if (assignment && assignment.status == 0) {
          <span
          class="badge fs-14 rounded-pill py-1 bg-warning ">Pending</span>
        }
        @if (assignment && assignment.status == 1) {
          <span
          class="badge fs-14 rounded-pill py-1 bg-dark ">Closed</span>
        }
        @if (assignment && assignment.status == 2) {
          <span
          class="badge fs-14 rounded-pill py-1 bg-primary ">Re-Opened</span>
        }
        @if (assignment && assignment.status == 3) {
          <span class="badge fs-14 rounded-pill py-1 bg-info ">Follow
          up</span>
        }
        @if (assignment && assignment.is_deleted == 1) {
          <span
          class="badge fs-14 rounded-pill py-1 bg-danger ">Deleted</span>
        }
        @if (assignment && assignment.cus_dispute_id > 0) {
          <span
            class="badge fs-14 rounded-pill py-1 bg-info  me-1" style="padding: 5px !important;">Customer reported
          dispute</span>
        }
      </div>
      @if (phase_info) {
        <br>
        }
        @if (phase_info) {
          <div class="d-flex align-items-center">
            @if (phase_info && phase_info.admin_name) {
              <div class="me-5">
                <h5 class="fs-16 fw-600"><i class="fa fa-user"></i> Current Account Manager : <strong>{{phase_info &&
              phase_info.admin_name ? phase_info.admin_name : ""}}</strong></h5>
            </div>
          }
          @if (phase_info && phase_info.phase_id) {
            <div class="">
              @if (phase_info && phase_info.phase_id == 1) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>PHASE 0</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 2) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>PHASE 1</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 3) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>PHASE 2</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 4) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>PHASE 3</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 5) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>LOW POTENTIAL AUTOMATIC</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 6) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>LOW POTENTIAL MANUAL</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 7) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>RETENTION AUTOMATIC</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 8) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>RETENTION MANUAL</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 9) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>REVIVAL</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 10) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>ACTIVATION</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 11) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>REVIVAL</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 12) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>REVIVAL</strong></h5>
              }
              @if (phase_info && phase_info.phase_id == 13) {
                <h5 class="fs-16 fw-600"><i class="fa fa-level-up"></i>
                Current Business Phase : <strong>REVIVAL</strong></h5>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="card-body">

      @if (assignment) {
        <div>
          @if (assignment && assignment.is_deleted == 1) {
            <p class="text-danger">This note has been deleted.</p>
          }
          <!--Business Info-->
          @if (assignment.doctor_id > 0) {
            <div class="border mb-1 p-2 rounded note-item">
              <p class="fs-18 fw-600 hex-65-grey">Business Information</p>
              <div class="row">
                <div class="col">
                  <b  class="fs-14 fw-700">Name: </b>
                  <a [routerLink]="'/app/business/details/'+assignment.doctor_id">
                    {{assignment.doctor_name}}
                  </a>
                  <br>
                    <b  class="fs-14 fw-700">Email: </b>{{assignment.doctor_email}}<br />
                    @if (assignment && assignment.call_req_doc_mobile) {
                      <div>
                        <strong>Request Generated For:
                        </strong>{{assignment.call_req_doc_mobile ? (assignment.call_req_doc_mobile | phoneFormat):'-'}}
                      </div>
                    }
                  </div>
                  <div class="col">
                    <b  class="fs-14 fw-700">Mobile: </b>{{assignment.doctor_mobile?(assignment.doctor_mobile | phoneFormat):'-'}}
                    <br>
                      <b  class="fs-14 fw-700">Business Name: </b> {{assignment.practice_name || 'NA'}}<br>
                      @if (isTerminalOrder) {
                        @if (deliveryAddress) {
                          <b class="fs-14 fw-700">Delivery Address: </b> {{ deliveryAddressLine }}<br>
                        }
                        <b class="fs-14 fw-700">Quantity: </b> {{ terminalQuantity }}<br>
                        @for (device of trackedDevices; track device.tdi_id) {
                          <b class="fs-14 fw-700">Track Link{{ terminalDevices.length > 1 ? ' (#' + device.tdi_id + ')' : '' }}: </b>
                          <a [href]="device.track_link" target="_blank" rel="noopener noreferrer">{{ device.track_link }}</a><br>
                        }
                      }
                      @if (assignment.call_req_dt) {
                        <span><b class="fs-14 fw-700">Requested Date:</b>
                      {{(assignment.call_req_dt | date: 'MM/dd/yyyy') || '-'}}</span>
                      }<br>
                      @if (assignment.call_req_time) {
                        <span><b class="fs-14 fw-700">Requested
                        Time:</b>{{(assignment.call_req_dt && (assignment.call_req_dt | date: 'hh:mm a': timezone)) || '-'}}
                      </span>
                      }<br>
                      <!-- ({{timezoneName}}) -->
                      @if (assignment.call_req_dt) {
                        <span><b class="fs-14 fw-700">Localtime :
                        </b>{{assignment.call_req_dt | date:'MM/dd/yyyy hh:mm a':timezone}}</span>
                      }
                    </div>
                    @if (assignment.doctor_agent_id > 0) {
                      <div class="col">
                        <b class="fs-14 fw-700">Agent Name: </b> {{assignment.doc_agent_title}} {{assignment.doc_agent_name}}<br>
                        <b class="fs-14 fw-700">Agent Email: </b>{{assignment.doc_agent_email}}<br />
                      </div>
                    }
                  </div>
                </div>
              }
              <!--Patient Info-->
              @if (assignment.split_token != 0 && assignment.split_token != null) {
                <div class="border mb-1 p-2 rounded note-item">
                  <p class="fs-18 fw-600 hex-65-grey">{{assignment.is_arv2 == 1 ? 'Debt Recovery' : '' }} Proposal Information</p>
                  <div class="row">
                    <div class="col">
                      <b class="fs-14 fw-700">Proposal ID: </b>
                      @if (assignment.is_arv2 == 0) {
                        <a
                          [routerLink]="'/app/proposal/details/'+assignment.split_req_id">{{assignment.contract_patient_token?assignment.contract_patient_token:'
                        Go to Details'}}</a>
                      }
                      @if (assignment.is_arv2 == 1 && assignment.proposal_status == 'PAID_FULL' ) {
                        <a
                          [routerLink]="'/app/debt-recovery/payment/'+assignment.split_req_id">{{assignment.contract_patient_token?assignment.contract_patient_token:'
                        Go to Details'}}</a>
                      }
                      @if (assignment.is_arv2 == 1 && assignment.proposal_status != 'PAID_FULL' ) {
                        <a
                          [routerLink]="'/app/debt-recovery/details/'+assignment.split_req_id">{{assignment.contract_patient_token?assignment.contract_patient_token:'
                        Go to Details'}}</a>
                      }
                      <br>
                        <b class="fs-14 fw-700">Name: </b>
                        <span class="text-success fw-700">
                          {{assignment.patient_title}} {{assignment.patient_first_name}} {{assignment.patient_last_name}}
                        </span>
                        <br>
                          <b class="fs-14 fw-700">Email: </b>{{assignment.patientEmail}}<br />
                        </div>
                        <div class="col">
                          <b class="fs-14 fw-700">Mobile: </b>{{assignment.patientMobile?(assignment.patientMobile | phoneFormat):'-'}}
                        </div>
                      </div>
                    </div>
                  }
                  <!--Contract Info-->
                  @if (assignment.contract_id > 0) {
                    <div class="aa border mb-1 p-2 rounded note-item">
                      <p class="mb-2 fs-18 fw-600 hex-65-grey">Contract Information</p>
                      <div class="row">
                        <div class="col">
                          <span class="fs-14 fw-700">Contract Code: </span>
                          <a [routerLink]="'/app/contracts/details/'+assignment.contract_id">{{assignment.contract_code}}</a>
                          <br>
                            <span class="fs-14 fw-700">Next Payment Date: </span> {{(assignment.next_payment_date | date:'MM/dd/yyyy':'+0000') || '-'}}
                            <br>
                              <span class="fs-14 fw-700">Status: </span>
                              <span
                                [ngClass]="{'text-success':assignment.pf_status<3||assignment.pf_status==4,'text-warning':assignment.pf_status==3,'text-danger':assignment.pf_status==5}">
                                @if (assignment.pf_status<3) {
                                  <span>Active</span>
                                }
                                @if (assignment.pf_status==3) {
                                  <span>Overdue</span>
                                }
                                @if (assignment.pf_status==4) {
                                  <span>Completed</span>
                                }
                                @if (assignment.pf_status==5) {
                                  <span>Canceled</span>
                                }
                              </span>
                            </div>
                            <div class="col">
                              <span class="fs-14 fw-700">Financed Amount: </span> {{assignment.wp_display_logo}}{{assignment.financed_amount ? (assignment.financed_amount | number:'1.2-2') : '-'}}
                              <br>
                                <span class="fs-14 fw-700">Number of Missing Payments: </span> {{assignment.missing_payments}}
                                @if (assignment.request_type_name && assignment.request_type != 'doctor_dispute_documents') {
                                  <div>
                                    <span class="fs-14 fw-700">Approval Needed for:</span> {{assignment.request_type_name || '-'}}
                                    <!-- <span *ngIf="assignment.is_approved == 0"></span> -->
                                    @if (assignment.is_approved == 1) {
                                      <span tooltip="Approved">
                                        <i class="fa fa-check text-success"></i>
                                      </span>
                                    }
                                    @if (assignment.is_approved == 2) {
                                      <span tooltip="Rejected">
                                        <i class="fa fa-close text-danger"></i>
                                      </span>
                                    }
                                    <br>
                                      @if (assignment.is_approved == 0 || assignment.is_approved == 2) {
                                        <a  (click)="approveRejectModal(1)"
                                          class="btn btn-primary btn-xs rounded-pill py-1 mt-2 pointer"
                                          >
                                          <small>Approve</small>
                                        </a>
                                      }
                                      @if (assignment.is_approved == 0 || assignment.is_approved == 1) {
                                        <a  (click)="approveRejectModal(2)"
                                          class="btn btn-danger btn-xs rounded-pill py-1 ms-2 mt-2 pointer"
                                          >
                                          <small>Reject</small>
                                        </a>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          <!--CB and PP Info-->
                          @if (assignment.pp_id > 0) {
                            <div class="border mb-1 p-2 rounded note-item">
                              <p class="fs-18 fw-600 hex-65-grey">Payment Information</p>
                              <div class="row">
                                <div class="col">
                                  <b class="fs-14 fw-700">Payment ID: </b>
                                  @if (assignment.is_ar == 0) {
                                    <a [routerLink]="'/app//payment-processing/'+assignment.pp_id">{{assignment.payment_process_code?assignment.payment_process_code:' Go to Details'}}</a>
                                  }
                                  @if (assignment.is_ar == 1) {
                                    <a [routerLink]="'/app/accounts-receivable/'+assignment.pp_id">{{assignment.payment_process_code?assignment.payment_process_code:' Go to Details'}}</a>
                                  }
                                  <br>
                                    <b class="fs-14 fw-700">Business Name: </b><a [routerLink]="'/app/business/details/'+assignment.pp_doctor_id">
                                    {{assignment.pp_practice_name ? assignment.pp_practice_name : (assignment.pp_doctor_name)}}
                                  </a>
                                  <br>
                                    <b class="fs-14 fw-700">Business Email: </b> {{assignment.pp_practice_email ? assignment.pp_practice_email : assignment.pp_doctor_email}}
                                    <br>
                                      <b class="fs-14 fw-700">Business Mobile: </b> {{assignment.pp_practice_mobile?(assignment.pp_practice_mobile | phoneFormat ):(assignment.pp_doctor_mobile | phoneFormat)}}
                                    </div>
                                    <div class="col">
                                      <b class="fs-14 fw-700">Customer Name: </b> {{assignment.pp_patient_name?assignment.pp_patient_name:' -'}}
                                      <br>
                                        <b class="fs-14 fw-700">Customer Email: </b> {{assignment.pp_patient_email?assignment.pp_patient_email:' -'}}
                                        <br>
                                          <b class="fs-14 fw-700">Customer Mobile: </b> {{assignment.pp_patient_mobile?(assignment.pp_patient_mobile | phoneFormat):' -'}}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  <!--Partner Info-->
                                  @if (assignment.partner_id > 0) {
                                    <div class="border mb-1 p-2 rounded note-item">
                                      <p class="fs-18 fw-600 hex-65-grey">Partner Information</p>
                                      <div class="row">
                                        <div class="col">
                                          <b class="fs-14 fw-700">Name: </b> <a
                                          [routerLink]="'/app/partners/profile/'+assignment.partner_id">{{assignment.partner_title}}
                                        {{assignment.partner_name}}</a>
                                        <br>
                                          <b class="fs-14 fw-700">Email: </b> {{assignment.partner_email}}<br/>
                                          @if (assignment && assignment.call_req_doc_mobile) {
                                            <div>
                                              <strong>Request Generated For:
                                              </strong>{{assignment.call_req_doc_mobile?(assignment.call_req_doc_mobile | phoneFormat ):'-'}}
                                            </div>
                                          }
                                        </div>
                                        <div class="col">
                                          <b class="fs-14 fw-700">Phone: </b>{{assignment.partner_mobile?(assignment.partner_mobile | phoneFormat ):'-'}}
                                          <br>
                                            @if (assignment.call_req_dt) {
                                              <span><b class="fs-14 fw-700">Requested Date:</b>
                                            {{(assignment.call_req_dt | date: 'MM/dd/yyyy') || '-'}}</span>
                                            }<br>
                                            @if (assignment.call_req_time) {
                                              <span>
                                                <b class="fs-14 fw-700">Requested Time:</b>{{(assignment.call_req_dt && (assignment.call_req_dt | date: 'hh:mm a': timezone)) || '-'}}
                                              ({{timezoneName}})</span>
                                              }<br>
                                              @if (assignment.call_req_dt) {
                                                <span>
                                                  <b class="fs-14 fw-700">Localtime :</b>{{assignment.call_req_dt | date:'MM/dd/yyyy hh:mm a':timezone}}</span>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        }
                                        <!--Customer Info-->
                                        @if (assignment.patient_id > 0) {
                                          <div class="border mb-1 p-2 rounded note-item">
                                            <p class="fs-18 fw-600 hex-65-grey">Customer Information</p>
                                            <div class="row">
                                              <div class="col">
                                                <b class="fs-14 fw-700">Name: </b>
                                                <a [routerLink]="'/app/customers/profile/'+assignment.patient_id">
                                                  {{assignment.patient_title}} {{assignment.patient_first_name}} {{assignment.patient_last_name}}
                                                </a>
                                                <br>
                                                  <b class="fs-14 fw-700">Email: </b> {{assignment.patient_email}}<br />
                                                  @if (assignment && assignment.call_req_doc_mobile) {
                                                    <div>
                                                      <b  class="fs-14 fw-700">Request Generated For:
                                                      </b>{{assignment.call_req_doc_mobile?(assignment.call_req_doc_mobile | phoneFormat):'-'}}
                                                    </div>
                                                  }
                                                </div>
                                                <div class="col">
                                                  <b class="fs-14 fw-700">Mobile: </b>{{assignment.patient_mobile?(assignment.patient_mobile | phoneFormat):'-'}}
                                                  <br>
                                                    @if (assignment.call_req_dt) {
                                                      <span><b>Requested Date:</b>
                                                    {{(assignment.call_req_dt | date: 'MM/dd/yyyy') || '-'}}</span>
                                                    }<br>
                                                    @if (assignment.call_req_time) {
                                                      <span>
                                                        <b class="fs-14 fw-700">Requested Time:</b>{{(assignment.call_req_dt && (assignment.call_req_dt | date: 'hh:mm a': timezone)) || '-'}}
                                                      ({{timezoneName}})</span>
                                                      }<br>
                                                      @if (assignment.call_req_dt) {
                                                        <span>
                                                          <b class="fs-14 fw-700">Localtime :</b>{{assignment.call_req_dt | date:'MM/dd/yyyy hh:mm a':timezone}}</span>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                }
                                                <!--Callback request Info-->
                                                @if (formMetaDataInfo &&  assignment.action_type!='preapproval_business_leads') {
                                                  <div class="border mb-1 p-2 rounded note-item" >
                                                    <p class="fs-18 fw-600 hex-65-grey">Callback Form Information</p>
                                                    <div class="row">
                                                      <div class="col">
                                                        <b class="fs-14 fw-700">Name: </b> {{formMetaDataInfo.name}} <br>
                                                        <b class="fs-14 fw-700">Business Name: </b> {{formMetaDataInfo.practice_name || 'N.A.'}} <br>
                                                        <b class="fs-14 fw-700">Email: </b>{{formMetaDataInfo.email}}<br>
                                                        <b class="fs-14 fw-700">Request: </b> {{ assignment.request_type_name?assignment.request_type_name:assignment.action_value?assignment.action_value:'N/A'}} <br />
                                                        <b class="fs-14 fw-700">User Status: </b> @if (assignment.user_status == 1) {
                                                        <span>Registered</span>
                                                      } @else {
                                                        <span>Unregistered</span>
                                                      }
                                                      <br />
                                                      <br>
                                                      </div>
                                                      <div class="col">
                                                        <b class="fs-14 fw-700">Mobile: </b>{{assignment.call_req_doc_mobile | phoneFormat}} <br>
                                                        @if (assignment.call_req_dt) {
                                                          <span><b class="fs-14 fw-700">Requested Date:</b>
                                                        {{(assignment.call_req_dt | date: 'MM/dd/yyyy') || '-'}}</span>
                                                        }<br>
                                                        @if (assignment.call_req_time) {
                                                          <span><b class="fs-14 fw-700">Requested Time:
                                                          </b>{{(assignment.call_req_dt | date: 'hh:mm a': timezone ) || '-'}}
                                                        ({{timezoneName}})</span>
                                                        }<br>
                                                        @if (assignment.call_req_dt) {
                                                          <span><b class="fs-14 fw-700">Localtime :
                                                          </b>{{assignment.call_req_dt | date:'MM/dd/yyyy hh:mm a': timezone }}</span>
                                                          }<br>
                                                          @if (assignment.request_source == 1) {
                                                            <span> <b class="fs-14 fw-700">Requested From:</b> Application </span>
                                                          }
                                                          @if (assignment.request_source == 2) {
                                                            <span><b class="fs-14 fw-700">Requested From:</b> Website</span>
                                                            } <br />
                                                          </div>
                                                        </div>
                                                        @if (formMetaDataInfo.parent_id && formMetaDataInfo.parent_id != '') {
                                                          <div class="row">
                                                            <div class="col">
                                                              <p class="text-bold mb-2 h4">Associated Business Information</p>
                                                              <b class="fs-14 fw-700">Business Owner Name: </b> {{formMetaDataInfo.parent_name}} <br>
                                                              <b class="fs-14 fw-700">Business Owner Email: </b>{{formMetaDataInfo.parent_email}}
                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                    <!--Wordpress Enquiry Info-->
                                                    @if (assignment.wp_query_id && assignment.wp_query_id > 0) {
                                                      <div class="border mb-1 p-2 rounded note-item">
                                                        <p class="text-bold mb-2 h4">Inquiry Information</p>
                                                        <div class="row">
                                                          <div class="col">
                                                            <b class="fs-14 fw-700">Name: </b> {{assignment.wp_name}} <br>
                                                            <b class="fs-14 fw-700">Email: </b>{{assignment.wp_email}}<br>
                                                            <b class="fs-14 fw-700">Address: </b>{{assignment.wp_address?assignment.wp_address:'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">State: </b> {{assignment.wp_state_name?assignment.wp_state_name:'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">Can travel upto: </b> {{assignment.wp_distance?assignment.wp_distance+' miles':'N.A.'}}
                                                          </div>
                                                          <div class="col">
                                                            <b class="fs-14 fw-700">Phone: </b>{{assignment.wp_phone_country_code && !assignment.wp_phone.includes(assignment.wp_phone_country_code) ? (assignment.wp_phone_country_code): !assignment.wp_phone.includes(assignment.wp_phone_country_code) ? '+1' : ''}} {{assignment.wp_phone?(assignment.wp_phone | phoneFormat):'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">Specialty: </b> {{assignment.wp_speciality?assignment.wp_speciality:'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">Country: </b> {{assignment.wp_country_name?assignment.wp_country_name:'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">City: </b> {{assignment.wp_city_name?assignment.wp_city_name:'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">Zip: </b> {{assignment.wp_zip?assignment.wp_zip:'N.A.'}} <br>
                                                            <b class="fs-14 fw-700">Type: </b> {{assignment.wp_type === 1 ? 'Business' : assignment.wp_type == 2 ? 'Customer' : 'Partner'}}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                    <!--Preapproval lead Info-->
                                                    @if (assignment.action_type == 'preapproval_business_leads') {
                                                      <div class="border mb-1 p-2 rounded note-item">
                                                        <p class="fs-18 fw-600 hex-65-grey">Pre-Approval leads Information</p>
                                                        <div class="row">
                                                          <div class="col">
                                                            <b class="fs-14 fw-700">Application ID: </b>
                                                            <a [routerLink]="'/app/patients/customers-leads/details/'+assignment.leads_application_id">
                                                              {{assignment.leads_application_id}}
                                                            </a> <br>
                                                            <b>Name: </b>
                                                            {{assignment.leads_customer_first_name}} {{assignment.leads_customer_last_name}}
                                                          </div>
                                                          <div class="col">
                                                            <b class="fs-14 fw-700">Email: </b> {{assignment.leads_customer_email?assignment.leads_customer_email:'NA'}}<br />
                                                            <b class="fs-14 fw-700">Mobile: </b>{{assignment.leads_customer_mobile?(assignment.leads_customer_mobile | phoneFormat):'-'}}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    }
                                                    <!--Admin Info-->
                                                    @if (!is_lead) {
                                                      <div class="border mb-1 p-2 rounded note-item">
                                                        <div class="row">
                                                          <div class="col-6">
                                                            <div class="d-flex align-items-center">
                                                              @if (assignment.contact_type==1) {
                                                                <i tappable class="fa fa-sign-in me-2" [tooltip]="'Incoming Call'"
                                                                ></i>
                                                              }
                                                              @if (assignment.contact_type==2) {
                                                                <i tappable class="fa fa-sign-out me-2" [tooltip]="'Outgoing Call'"
                                                                ></i>
                                                              }
                                                              @if (assignment.contact_type==3) {
                                                                <i tappable class="fa fa-envelope me-2" [tooltip]="'Email'"></i>
                                                              }
                                                              @if (assignment.contact_type==4) {
                                                                <i tappable class="fa fa-envelope me-2" [tooltip]="'Text'"></i>
                                                              }
                                                              @if (assignment.contact_type==5) {
                                                                <i tappable class="fa fa-envelope me-2" [tooltip]="'Chat'"></i>
                                                              }
                                                              @if (assignment.contact_type==6) {
                                                                <i tappable class="fa fa-envelope me-2" [tooltip]="'Verification Call'"
                                                                ></i>
                                                              }
                                                              @if (assignment.contact_type==7) {
                                                                <i tappable class="fa fa-envelope me-2" [tooltip]="'Potential Business'"
                                                                ></i>
                                                              }
                                                              @if (assignment.contact_type==8) {
                                                                <i tappable class="fa fa-envelope me-2" [tooltip]="'Validation'"
                                                                ></i>
                                                              }
                                                              <p class="m-0 fs-14">
                                                                <strong class="admin_name">{{assignment.admin_name}}</strong>
                                                                {{assignment.date_added | date:'medium':timezone}} ({{timezoneName}})
                                                                @if (assignment.action_type != 'wordpress_support_query') {
                                                                  <span>
                                                                    @if (assignment.priority <= 1) {
                                                                      <span class="ms-2 badge bg-info">low priority</span>
                                                                    }
                                                                    @if (assignment.priority == 2) {
                                                                      <span class="ms-2 badge bg-warning">medium priority</span>
                                                                    }
                                                                    @if (assignment.priority == 3) {
                                                                      <span class="ms-2 badge bg-danger">high priority</span>
                                                                    }
                                                                  </span>
                                                                }
                                                              </p>
                                                            </div>
                                                          </div>
                                                          @if (assignment.action_type != 'wordpress_support_query' && assignment.action_type != 'business_call_request' && !(assignment && assignment.cus_dispute_id > 0)) {
                                                            <div class="col-6 text-end">
                                                              <span class="fw-700 fs-14">Result of Call: </span>
                                                              @if (assignment.contact_result==1) {
                                                                <span>Voicemail</span>
                                                              }
                                                              @if (assignment.contact_result==2) {
                                                                <span>No Answer</span>
                                                              }
                                                              @if (assignment.contact_result==3) {
                                                                <span>Voicemail Full</span>
                                                              }
                                                              @if (assignment.contact_result==4) {
                                                                <span>Answered</span>
                                                              }
                                                            </div>
                                                          }
                                                        </div>
                                                        <div class="speech-bubble">
                                                          <p style="margin-bottom:0;">
                                                            @if (assignment && assignment.callback_reason && assignment.callback_reason!=null) {
                                                              <span class="pr-1"><strong>Reason:</strong>
                                                            {{assignment.callback_reason}}</span>
                                                          }
                                                        </p>
                                                        @if ((assignment.wp_message || assignment.note)) {
                                                          <p>
                                                            <span class=" show-enter fs-14 hex-65-grey"><strong>Message/Note:</strong>
                                                          <span [innerHtml]="(assignment.wp_message ?? assignment.note ?? '').replaceAll('\n', '<br/>')"></span>
                                                          @if (assignment && assignment.wp_src_url) {
                                                            <div>{{assignment.wp_src_url}} </div>
                                                          }
                                                        </span>
                                                      </p>
                                                    }
                                                  </div>
                                                  @if (assignment && assignment.req_docs && assignment.req_docs.length>0) {
                                                    <div
                                                      class="d-flex align-items-center">
                                                      @for (doc of assignment.req_docs; track doc) {
                                                        <a tappable [href]="doc.file_url" target="_blank"
                                                          class="d-flex align-items-center justify-content-center m-1 border bg-dark pointer"
                                                          style="height: 80px; width: 80px;">
                                                          <img [src]="doc.thumb_url" alt="" class="img-fluid"
                                                            onError="this.src='assets/images/png/attachment.png';">
                                                          </a>
                                                        }
                                                      </div>
                                                    }
                                                    <p>
                                                      <i tappable class="fa fa-user me-2"
                                                      [tooltip]="'Assigned to'"></i>@if (assignment.action_type != 'internal_ticket_new_business_registration') {
                                                      <span class="fs-14 fw-700 Message/Note">{{assignment.assigned_admin_name ? assignment.assigned_admin_name:'Not Assigned Yet'}}</span>
                                                    }
                                                    <!-- only for new business signed up -->
                                                    @if (assignment.action_type == 'internal_ticket_new_business_registration') {
                                                      <span class="fs-14 fw-700 Message/Note">{{assignment.first_admin_name ? assignment.first_admin_name:'Not Assigned Yet'}}</span>
                                                    }
                                                    |
                                                    <i tappable class="fa fa-calendar me-2"
                                                      [tooltip]="'Follow up'"></i><span class="fs-14 fw-700 Message/Note">{{assignment.followup_date?(assignment.followup_date | date:'MM/dd/yyyy hh:mm:ss aaa': timezone):'Not Available'}}</span>
                                                      <br>
                                                      </p>
                                                    </div>
                                                  }
                                                </div>
                                              } @else {
                                                <div class="text-center border  p-4  rounded">
                                                  <span class="fa fa-exclamation-triangle fa-5x"></span>
                                                  <p class="m-0 mt-2">Information not Available!</p>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-3 col-12">
                                          <div class="card b">
                                            <div class="card-header bg-gray-lighter text-bold">Actions</div>
                                            <div class="list-group">
                                              <button  class="list-group-item  fs-14 fw-600 list-group-item-action text-primary"
                                                (click)="location.back()">
                                                <i class="fa fa-angle-left"></i> Back
                                              </button>
                                              <button  class="list-group-item  fs-14 fw-600 list-group-item-action"
                                                (click)="setStatusForm();changeStatusModal();setFollowDate()"
                                                [disabled]="is_lead || (assignment && assignment.is_deleted == 1)">
                                                <i class="fa fa-pencil"></i> Change Status / Reassign
                                              </button>
                                              @if (isTerminalOrder) {
                                                <span class="d-block" [tooltip]="shipmentBlockedReason">
                                                  <button type="button" class="list-group-item fs-14 fw-600 list-group-item-action w-100 text-start"
                                                    (click)="openTerminalShipmentModal('shipment')" [disabled]="!!shipmentBlockedReason">
                                                    <i class="fa fa-pencil"></i> {{ allDevicesShipped ? 'Edit Shipment Details' : 'Add Shipment Details' }}
                                                  </button>
                                                </span>
                                                <!-- <span class="d-block" [tooltip]="deliveryBlockedReason">
                                                  <button type="button" class="list-group-item fs-14 fw-600 list-group-item-action w-100 text-start"
                                                    (click)="openTerminalShipmentModal('delivery')" [disabled]="!!deliveryBlockedReason">
                                                    <i class="fa fa-pencil"></i> Update Delivery Date
                                                  </button>
                                                </span> -->
                                              }
                                              <!-- <button  class="list-group-item  fs-14 fw-600 list-group-item-action" (click)="reassignModal.show()"
                                              [disabled]="assignment && assignment.is_deleted == 1">
                                              <i class="fa fa-edit"></i> Reassign Request
                                            </button> -->
                                            <span >
                                              @if (assignment.request_type == 'doctor_dispute_documents') {
                                                <button  class="list-group-item  list-group-item-action"
                                                  (click)="viewDocument()"        >
                                                  <i class="fa fa-eye"></i> View Documents
                                                </button>
                                              }
                                            </span>
                                            <button  class="list-group-item  fs-14 fw-600 list-group-item-action" (click)="addNoteModal()"
                                              [disabled]="is_lead || (assignment && assignment.is_deleted == 1)">
                                              <i class="fa fa-plus"></i> Add Notes
                                            </button>
                                            <!-- <span *ngIf="assignment">
                                            <button  class="list-group-item  fs-14 fw-600 list-group-item-action"
                                              [routerLink]="'/app/users/assignments/inquiry_people/'+assignment.req_id"
                                              *ngIf="assignment.wp_query_id && assignment.wp_query_id > 0 && assignment.wp_type !== 1">
                                              <i class="fa fa-search"></i> Related Businesses/Leads
                                            </button>
                                          </span> -->

                                          @if (assignment && !_shared.routerAuth.restricted_buttons.edit ) {
                                            <span>
                                              @if (assignment && assignment.wp_query_id && assignment.wp_query_id > 0 && assignment.wp_type !== 1) {
                                                <button  class="list-group-item  fs-14 fw-600 list-group-item-action"
                                                  (click)="updateInformationInquiryModal()"
                                                  [disabled]="assignment && assignment.is_deleted == 1">
                                                  <i class="fa fa-pencil-square-o"></i> Edit Details
                                                </button>
                                              }
                                            </span>
                                          }
                                          @if (assignment.action_type == 'wrongly_formatted_file_uploaded') {
                                            <span>
                                              <button  class="list-group-item  list-group-item-action fs-14 fw-600"
                                                [routerLink]="['/app/debt-recovery/raw-files']"
                                                [queryParams]="{ doctor_id: assignment.doctor_id}"
                                                [disabled]="assignment && assignment.is_deleted == 1">
                                                <i class="fa fa-upload"></i> Upload Debt Recovery Formatted File
                                              </button>
                                            </span>
                                          }

                                        </div>
                                      </div>

                                      @if (isTerminalOrder && terminalDevices.length) {
                                        <div class="card b mt-3 terminal-devices-card">
                                          <div class="card-header bg-gray-lighter text-bold">Terminal Devices ({{ terminalDevices.length }})</div>
                                          <div class="list-group">
                                            @for (device of terminalDevices; track device.tdi_id) {
                                              <div class="list-group-item terminal-device-item">
                                                <div class="d-flex justify-content-between align-items-center gap-2 mb-1">
                                                  <span class="fw-700 fs-14">#{{ device.tdi_id }}</span>
                                                  <span class="terminal-status" [attr.data-status]="device.status">{{ terminalStatusLabel(device.status) }}</span>
                                                </div>
                                                <p class="m-0 fs-13">Serial: <span>{{ device.serial_number || 'N/A' }}</span></p>
                                                <p class="m-0 fs-13">
                                                  Tracking:
                                                  @if (device.track_link && device.tracking_number) {
                                                    <a [href]="device.track_link" target="_blank" rel="noopener noreferrer">{{ device.tracking_number }}</a>
                                                  } @else {
                                                    <span>{{ device.tracking_number || 'N/A' }}</span>
                                                  }
                                                  @if (device.carrier) { <span class="text-muted">({{ device.carrier }})</span> }
                                                </p>
                                                <p class="m-0 fs-13">Shipped: <span>{{ device.ship_date ? (terminalDate(device.ship_date) | date: 'MM/dd/yyyy') : 'N/A' }}</span></p>
                                                <p class="m-0 fs-13">Est. Delivery: <span>{{ device.est_delivery_date ? (terminalDate(device.est_delivery_date) | date: 'MM/dd/yyyy') : 'N/A' }}</span></p>
                                                <p class="m-0 fs-13">Delivered: <span>{{ device.delivery_date ? (terminalDate(device.delivery_date) | date: 'MM/dd/yyyy') : 'N/A' }}</span></p>
                                                @if (terminalDevices.length > 1 && assignment.is_deleted != 1) {
                                                  <div class="d-flex gap-3 mt-1">
                                                    <button type="button" class="btn btn-link p-0 fs-13" (click)="openTerminalShipmentModal('shipment', device.tdi_id)">Shipment</button>
                                                    <!-- Delivery is recorded from the shipment form now, by setting the status to Delivered.
                                                    @if (device.ship_date) {
                                                      <button type="button" class="btn btn-link p-0 fs-13" (click)="openTerminalShipmentModal('delivery', device.tdi_id)">Delivery</button>
                                                    }
                                                    -->
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col-12">
                                      <div class="card">
                                        <div class="card-header bg-gray-lighter text-bold">
                                          Notes
                                        </div>
                                        <div class="card-body">
                                          @if (notes && notes.length) {
                                            <div>
                                              @for (note of notes; track note) {
                                                <div class="border rounded mb-2 p-2">
                                                  @if (note.is_cron == 0) {
                                                    <p class="fs-14"><b>{{note.admin_name}}</b> - {{note.date_added | date:'medium':timezone}} ({{timezoneName}})</p>
                                                  }
                                                  @if (note.is_cron == 1) {
                                                    <p class="fs-14"><b>System</b> - {{note.date_added | date:'medium':timezone}} ({{timezoneName}})</p>
                                                  }
                                                  <p class="speech-bubble show-enter fs-14">
                                                    @if (note.contact_type) {
                                                      <span>Type of Contact: &nbsp; {{note.contact_name}}</span><br>
                                                    }
                                                    @if (note.contact_result) {
                                                      <span>Result of Contact: &nbsp; {{note.result_value}}</span><br>
                                                    }
                                                    @if (note.followup_date) {
                                                      <span>Follow up Date: &nbsp; {{note.followup_date | date: 'MM/dd/yyyy':timezone}}</span><br>
                                                      }<strong>Note: &nbsp; </strong>
                                                    <span [innerHTML]="note.note ? note.note.replaceAll('\n','<br/>') : ''" > </span>
                                                    <!-- <span [textContent]="note.note" style="white-space: pre-line;"> </span> -->
                                                  </p>
                                                  @if (note && note.note_docs && note.note_docs.length>0) {
                                                    <div
                                                      class="d-flex align-items-center">
                                                      @for (doc of note.note_docs; track doc) {
                                                        <a tappable [href]="doc.file_url" target="_blank"
                                                          class="d-flex align-items-center justify-content-center m-1 border bg-dark pointer"
                                                          style="height: 80px; width: 80px;">
                                                          <img [src]="'assets/images/png/attachment.png'" alt="" class="img-fluid"
                                                            >
                                                          </a>
                                                        }
                                                      </div>
                                                    }
                                                    <div>
                                                      @if (note.reassigned_id && note.change_status != 1) {
                                                        <span>
                                                          <i class="fa fa-user" tooltip="Reassigned to"></i> {{note.reassigned_admin_name}}
                                                        </span>
                                                      }
                                                      @if (note.change_status == 1) {
                                                        <span class="badge bg-dark"><i class="fa fa-close"></i>
                                                      Closed</span>
                                                    }
                                                    @if (note.change_status == 2) {
                                                      <span class="badge bg-primary"><i class="fa fa-repeat"></i>
                                                    Re-Opened{{note.followup_date?' : '+(note.followup_date | date:'MM/dd/yyyy hh:mm:ss aaa': timezone):''}}</span>
                                                  }
                                                  @if (note.change_status == 3) {
                                                    <span class="badge bg-info"><i class="fa fa-calendar"></i>
                                                  Followup{{note.followup_date?' : '+(note.followup_date | date:'MM/dd/yyyy hh:mm:ss aaa': timezone):'Not Available'}}</span>
                                                }
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      } @else {
                                        <div class="text-center border  p-4  rounded">
                                          <span class="fa fa-exclamation-triangle fa-5x"></span>
                                          <p class="m-0 mt-2">Information not Available!</p>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>

                              @if (assignment && assignment.wp_query_id && assignment.wp_query_id > 0 && assignment.wp_type !== 1 && inquiry_email_sent_records && inquiry_email_sent_records.length) {
                                <div class="row"
                                  >
                                  <div class="col-12">
                                    <div class="card">
                                      <div class="card-header bg-gray-lighter text-bold">
                                        Email history for inquiry:
                                      </div>
                                      <div class="table-responsive search_doctor_table">
                                        <table class="table">
                                          <thead>
                                            <tr>
                                              <th>S No.</th>
                                              <th>Business Owner Name</th>
                                              <th>Business Owner email</th>
                                              <th>No Of Emails Sent</th>
                                              <th>Sender Admin</th>
                                              <th>Last Sent Date And Time</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            @for (record of inquiry_email_sent_records; track record; let i = $index) {
                                              <tr>
                                                <td>{{(i+1)}}</td>
                                                <td>
                                                  {{record.full_name ? record.full_name : '-'}}
                                                </td>
                                                <td>{{record.lead_doctor_email ? record.lead_doctor_email : '-'}}</td>
                                                <td>{{record.number_of_email_sent ? record.number_of_email_sent : '-'}}</td>
                                                <td>{{record.admin_email ? record.admin_name + ' ('+record.admin_email + ')' : '-'}}</td>
                                                <td>{{record.date_created ? (record.date_created | date:'MMM dd, y, h:mm a' : timezone ): '-'}}</td>
                                              </tr>
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="row border-top pt-2 align-items-center" *ngIf="doctorsList && doctorsList.length">
                                  <div class="col-md-6 col-sm-12">
                                    <p class="text-bold">
                                      Showing {{(1+(resData.pageNumber - 1) * 10)}} to {{(doctorsList.length + (resData.pageNumber - 1) *
                                      10)}} of {{resData.totalRecords || 'all'}}
                                    </p>
                                  </div>
                                  <div class="col-md-6 col-sm-12">
                                    <pagination class="pagination-sm float-md-right" [totalItems]="resData.totalRecords" [maxSize]="5"
                                      [boundaryLinks]="true" [rotate]="false" (pageChanged)="pageChanged($event)" [(ngModel)]="resData.pageNumber">
                                    </pagination>
                                  </div>
                                </div> -->
                              </div>
                            }

                          </div>